import React from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import { useStoreState } from 'easy-peasy';
import {
	Box,
} from '@mui/material';
import SearchForm from './SearchForm';
// import SearchResult from './SearchResult';

const PACheck = () => {
	const { orgId } = useParams();
	const brandingData = useStoreState((state) => state?.paCheck?.brandingData);

	// React.useEffect(() => {
	// 	paCheckAction.getProceduresList();
	// 	console.log('test', formSubmitted, searchResult);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	return (
		<Box component="section" className="headerBox">
			<Grid container className="container">
				<Grid item size={12}>
					<SearchForm orgId={orgId} configRules={brandingData?.config_rules} />
				</Grid>
			</Grid>
		</Box>
	)
}

export default PACheck;